import React from "react";
import NotFound from "../NotFound";
import Loader from "../Loader";
import PageHeader from "../PageHeader";
import PostItem from "../PostItem";
import Banners from "../Banners";
import { Pagination } from "antd";
import { connect } from "react-redux";
import {
  fetchNews
} from "../../store/actions";

export class News extends React.Component {
  componentDidMount() {
    this.props.fetchNews();
  }

  onPageChange = (page) => {
    this.props.fetchNews({ page: page });
  };

  renderItems = () => {
    const { newsState } = this.props;

    if (!newsState.settled) {
      return <Loader />;
    } else {
      if (newsState.results.length > 0) {
        return (
          <React.Fragment>
            {newsState.results.map((result) => {
              return (
                <PostItem
                  key={result.id}
                  prismicCtx={this.props.prismicCtx}
                  item={result}
                />
              );
            })}

            <Pagination
              pageSize={newsState.results_per_page}
              total={newsState.total_results_size}
              onChange={this.onPageChange}
            />
          </React.Fragment>
        );
      } else {
        return <NotFound />;
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <PageHeader title="News" />
        <div className="container pt-5 pb-5">
          <div className="row">
            <div className="col-12 col-md-4 col-lg-5 order-md-last mb-4 mb-md-0 main-image">
              <Banners
                bannerLocation="news"
                prismicCtx={this.props.prismicCtx}
              />
            </div>
            <div className="col-12 col-md-8 col-lg-7">
              {this.renderItems()}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  newsState: state.news,
});

export default connect(mapStateToProps, {
  fetchNews
})(News);


// WEBPACK FOOTER //
// ./src/components/pages/News.js